import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 auto;
    text-align: center;

    &:before{
      content: '•';
      display: block;
      color: ${theme.v3.colors.contextual.active[80]};
      margin-right: ${theme.v3.spacing.nano};
      font-size: ${theme.v3.font.sizes['2xhuge']};
    }
  `}
`;

export const Image = styled.img`
  ${({ theme }) => css`
    margin: ${theme.v3.spacing.md} auto 0;
    max-width: 130px;
  `}
`;

export const SecondTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[15]};
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 0px auto;
    max-width: 400px;
    text-align: center;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: ${theme.v3.spacing.xxs} auto 0px;
    max-width: 400px;
    text-align: center;
  `}
`;

export const PerksTitle = styled(Description)`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.min};
  `}
`;

export const PerksCard = styled.div`
  ${({ theme }) => css`
    padding: ${theme.v3.spacing.xxs} ${theme.v3.spacing.xl};
    border-radius: ${theme.v3.border.radius.md};
    border: 1px solid ${theme.v3.colors.neutral[90]};
    margin-top: ${theme.v3.spacing.xxxs};
  `}
`;

export const PerksList = styled.ul`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    justify-content: center;
    list-style: none;
    margin: 0px auto;
    padding: 0px;
    width: fit-content;
  `}
`;

export const PerkItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    align-items: flex-start;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.confortable};

    &:before{
      content: '✓';
      display: block;
      color: ${theme.v3.colors.contextual.active[70]};
      flex-shrink: 0;
      margin-right: ${theme.v3.spacing.nano};
    }
  `}
`;

export const ActionsRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${theme.v3.spacing.xxxs};
    margin: ${theme.v3.spacing.sm} auto 0;
  `}
`;

export const AdditionalInfo = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    margin: ${theme.v3.spacing.xxs} auto 0;
    max-width: 400px;
    text-align: center;
  `}
`;
